import {HOTB} from "../../HOTB";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/presentation/SimplePresentationRunner";
import {HOTBGameData} from "../../server/HOTBData";

export class FSIntroPresentation implements SimplePresentation {

    public shouldRun(): boolean {
        return this.isBonusGame() || this.isBonusUpgrade() || this.isCapMachineGame();
    }

    public start(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback();

        HOTB.keypadPlugin.setZeroBetSpinCounter(-1);
        HOTB.fsIntro.showIntro((): void => {
            controller.finish();
        }, controller);
    }

    private isCapMachineGame(): boolean {
        const gameData: HOTBGameData = HOTB.model.gameData,
            currMode: string = gameData.mode,
            nextMode: string = gameData.nextMode;

        let flag: boolean = false;

        if (currMode === ExtendedGameMode.CAPWIN_GAME && nextMode.includes(ExtendedGameMode.FREESPIN) && gameData.numberOfFreespinsPlayed === 0) {
            flag = true;
        }

        return flag;
    }

    private isBonusGame(): boolean {
        const gameData: HOTBGameData = HOTB.model.gameData,
            currMode: ExtendedGameMode = gameData.mode,
            nextMode: ExtendedGameMode = gameData.nextMode;

        let flag: boolean = false;

        if ((currMode === ExtendedGameMode.NORMAL || currMode === ExtendedGameMode.NORMAL_AVALANCHE)
            && ((nextMode === ExtendedGameMode.FREESPIN || nextMode === ExtendedGameMode.FREESPIN_AVALANCHE) ||
                (nextMode === ExtendedGameMode.FREESPIN_SUPER || nextMode === ExtendedGameMode.FREESPIN_SUPER_AVALANCHE))) {
            flag = true;
        }

        if (gameData.fsUpgradeToSuper && ((gameData.mode === ExtendedGameMode.FREESPIN || gameData.mode === ExtendedGameMode.FREESPIN_AVALANCHE) && gameData.nextMode === ExtendedGameMode.FREESPIN_SUPER)) {
            flag = true;
        }

        return flag;
    }

    private isBonusUpgrade(): boolean {
        const gameData: HOTBGameData = HOTB.model.gameData,
            currMode: ExtendedGameMode = gameData.mode,
            nextMode: ExtendedGameMode = gameData.nextMode;

        let flag: boolean = false;

        if ((currMode === ExtendedGameMode.FREESPIN || currMode === ExtendedGameMode.FREESPIN_AVALANCHE) && (nextMode === ExtendedGameMode.FREESPIN_SUPER || nextMode === ExtendedGameMode.FREESPIN_SUPER_AVALANCHE)) {
            flag = true;
        }

        return flag;
    }
}